import feather from 'feather-icons';

const loadIcons = (element = null) => {
  const parent = element || document;
  // If we use wrong icon, whole feather will crash and no further icons will be loaded
  // this will check if icons are vaild and will remove the feather if not
  var icons = Object.keys(feather.icons);
  Array.prototype.forEach.call(
    parent.querySelectorAll('[data-feather]'),
    function (el) {
      var icon = el.dataset.feather;
      if (icons.indexOf(icon) < 0) {
        console.warn('No such icon "' + icon + '" in feather, element', el);
        el.dataset.featherInvalid = icon;
        delete el.dataset.feather;
      }
    }
  );
  try {
    feather.replace();
  } catch (e) {
    console.error('Unable to load icons:', e);
  }
}

export default loadIcons;